module.exports = "<ul>\n  <li *ngFor=\"let ci of codeItems\" [ngClass]=\"{'protected': ci.protected}\">\n    <prg-code-item [event]=\"event\" [codeItem]=\"ci\"></prg-code-item>\n    <div class=\"children\" *ngIf=\"ci.codeItems?.length > 0\">\n      <prg-codeitem-list [event]=\"event\" [codeItems]=\"ci.codeItems\"></prg-codeitem-list>\n    </div>\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/quickstart-common/codeitem-list/codeitem-list.component.html
// module id = 1557
// module chunks = 2